<script lang="ts">
    import "@/app.css";
    import { marked } from 'marked';

    import type { ChatEntry, ChatPartial } from "./chatbotClientStore";

    import IconAssistant from "./IconRobot.svelte";
    import IconUser from "./IconUser.svelte";
    import Loading from "./Loading.svelte";
    type Props = {
        chatEntry: ChatEntry;
        windowMode: boolean | string;
    };

    let { chatEntry = $bindable(), windowMode }: Props = $props();
    let chatStr = $derived(partialsToString(chatEntry.partials || []))
    function partialsToString(partials: ChatPartial[]) {
        return partials
            .map((v) => v.content)
            .join("");
    }

    let messageDiv = $state() as HTMLDivElement;
    let chatContainer = $state() as HTMLElement | null;
    let shouldAutoScroll = $state(true);

    function findChatContainer() {
        if (!messageDiv) return null;
        // Find the parent container with scrolling
        let parent = messageDiv.parentElement;
        while (parent) {
            const styles = window.getComputedStyle(parent);
            if (styles.overflowY === 'auto' || styles.overflowY === 'scroll') {
                return parent;
            }
            parent = parent.parentElement;
        }
        return null;
    }

    function checkScrollPosition() {
        const container = chatContainer || findChatContainer();
        if (!container) return;

        const { scrollTop, scrollHeight, clientHeight } = container;
        // Consider user at bottom if within 100px of bottom
        shouldAutoScroll = scrollTop + clientHeight >= scrollHeight - 100;
    }

    function toView() {
        const container = chatContainer || findChatContainer();
        if (!container) return;

        if (shouldAutoScroll) {
            // Scroll to bottom of container
            container.scrollTo({
                top: container.scrollHeight,
                behavior: "smooth"
            });
        }
    }

    $effect(() => {
        if (!chatContainer) {
            chatContainer = findChatContainer();
            if (chatContainer) {
                // Add scroll event listener to track user scrolling
                chatContainer.addEventListener('scroll', checkScrollPosition);
            }
        }
    });


    $effect(() => {
        if (chatStr) {
            toView();
        }
    });
    </script>

<div class="chat-message flex {windowMode ? 'chat-message-fullpage' : ''} {chatEntry.role === 'assistant' ? 'chat-message-assistant' : 'flex-row-reverse'} gap-4" bind:this={messageDiv}>
    <div class="flex flex-col justify-center items-center w-12 h-12 rounded-full {chatEntry.role === 'assistant' && windowMode ? 'mt-10' : ''} {chatEntry.role === 'assistant' ? 'bg-emerald-100 text-emerald-600' : 'bg-blue-100 text-blue-600'}  ">
        <div class=" w-full h-full flex items-center justify-center p-3 mt-[-2px] ">
            {#if chatEntry.role === "assistant"}
                <IconAssistant />
                {:else}
                <IconUser />
                {/if}
        </div>

    </div>
    <div class="border chat-message-text-wrapper border-gray-300 rounded-2xl p-8 shadow-sm {chatEntry.role === 'assistant' ? 'mr-16 bg-white' : 'ml-16 bg-blue-600 text-white'}">
        {#if chatStr}
            {@html marked.parse(chatStr)}
        {/if}
        {#if chatEntry?.timestamp}
        <div class="flex align-center gap-4 text-md {chatEntry.role === 'assistant' ?  'text-gray-400' : 'text-blue-200' }">
            <div class="">
                {new Date(chatEntry.timestamp).toLocaleString("fi-FI", { hour12: false, hour: '2-digit', minute: '2-digit' }).replace(".", ":")}
            </div>

            {#if !chatEntry?.done}
                <div class=" flex items-center justify-center">
                <Loading width={25} height={8} />
                </div>
            {/if}
        </div>
        {/if}

    </div>

</div>
<style>
    .chat-message-fullpage.chat-message-assistant {
        .chat-message-text-wrapper {
            box-shadow: none;
            border-color: transparent;
        }
    }
    </style>
